import React from 'react';
import { User, Clock, UserCircle } from 'lucide-react';
import './FeatureCard.css';
import { CONTENT } from '../config/landingPageContent';

const FeatureCard = ({ Icon, title, description }) => (
  <div className="feature-card">
    <div className="feature-icon">
      <Icon size={24} />
    </div>
    <div className="feature-content">
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  </div>
);

const FeatureSection = ({ variant = 'default' }) => {
  const content = CONTENT[variant] || CONTENT.default;
  const features = content.features.map((f, i) => {
    const icons = [User, Clock, UserCircle];
    return { ...f, Icon: icons[i] };
  });

  return (
    <section className="feature-section">
      {features.map((feature, index) => (
        <FeatureCard
          key={index}
          Icon={feature.Icon}
          title={feature.title}
          description={feature.description}
        />
      ))}
    </section>
  );
};

export default FeatureSection;
